import { render, staticRenderFns } from "./UpsertShiftWorkConfigModal.vue?vue&type=template&id=35c9c5bc"
import script from "./UpsertShiftWorkConfigModal.vue?vue&type=script&lang=js"
export * from "./UpsertShiftWorkConfigModal.vue?vue&type=script&lang=js"
import style0 from "./UpsertShiftWorkConfigModal.vue?vue&type=style&index=0&id=35c9c5bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports